import React from 'react';
import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import { Wrapper } from '@components';

const Header = ({ stick = false, children }) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <Box width="100%" height={{ base: `3.5rem`, md: `5.125rem` }}>
      <Box
        as="header"
        width="100%"
        height={{ base: `3.5rem`, md: `5.125rem` }}
        position={stick ? `fixed` : `static`}
        boxShadow="base"
        bg="white"
        zIndex="2">
        <Wrapper>
          <Flex
            justify="space-between"
            alignContent="center"
            direction={isDesktop ? `row` : `row-reverse`}>
            {children}
          </Flex>
        </Wrapper>
      </Box>
    </Box>
  );
};

export default Header;
